export default function buyButton() {
  return {
    _id: false,
    type: 'droplet.buyButton',
    btnText: 'Add to Cart',
    product: null,
    mediaQueries: [
      {
        selector: '.drzBuyBtn:hover',
        properties: [
          {
            defaultColor: true,
            property: 'background-color',
            desktop: 'rgba(0, 0, 0, 0.7)',
            tablet: 'default',
            mobile: 'default',
          },
          {
            property: 'color',
            desktop: 'rgba(255, 255, 255, 1)',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
    ],
    pageCSS: '',
    bounceDroplet: false,
    isShared: false,
    templateRegion: false,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/buy-button/droplet.schema.js